import {FullPageSpinner} from "../components/loading/Spinner";
import {PageWithLayout} from "./Page";
import {Navigate} from "react-router-dom";
import {CentralContent} from "../components/central-content/CentralContent";
import {UserSettings} from "../components/settings/UserSettings";
import {useRequireAuth} from "./useRequireAuth";

export const SettingsPage = () => {
  const searchParams = new URLSearchParams(window.location.search);
  let origin = searchParams.get("redirect_origin") || undefined;
  if (!origin?.startsWith("https://") && !origin?.startsWith("http://")) {
    origin = "https://wakelet.com"
  }
  const disableHome = searchParams.get("disable-home") || "";
  const {loading, error, redirectTo} = useRequireAuth(origin);
  if (loading) {
    return <FullPageSpinner />
  }
  if (redirectTo) {
    window.location.assign(redirectTo);
    return <FullPageSpinner />
  }
  if (error) {
    return <Navigate to="/error"/>
  }
  return (
      <PageWithLayout variant="secondary" showHeader={disableHome!=="1"} returnTo={origin}>
        <CentralContent>
          <UserSettings/>
        </CentralContent>
      </PageWithLayout>
  );
};
